import React from 'react';
import Carousel from './Carousel';
import AboutSection from '../pages/AboutSection';
import ChooseUsSection from '../pages/ChooseUsSection';
import ToursSection from '../pages/ToursSection';
import CategorySection from '../pages/CategorySection';
import PlaceSection from '../pages/PlaceSection';
import TestimonialSection from '../pages/TestimonialSection';
import NewsSection from '../pages/NewsSection';
import { Helmet } from 'react-helmet';


const HeroSection = () => {
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



          <Helmet>
              <title>Pune to Mumbai Cab | S9 Travels | Contact: +91 8850328441</title>
              <meta 
                name="description" 
                content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
              />
              {/* Inject JSON-LD Schema */}
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            </Helmet>
        <Carousel/>
        <AboutSection/>
        <ChooseUsSection/>
        <ToursSection/>
        <CategorySection/>
        <PlaceSection/>
        <TestimonialSection/>
        <NewsSection/>
    </div>
  );
};

export default HeroSection;
